import React, { useEffect, useState } from 'react'
import { InputSalaryStyle } from './style'
import { InputSalaryProps } from '../../types/components/inputSalary'

export const InputSalary: InputSalaryProps = ({
  label,
  setSalary,
  salary,
  placeholder,
  isValidate = true,
  widthDiv = '100%',
  disabledInput
}) => {
  const [disabled, setDisabled] = useState(false)
  const handleChange = (e: { target: HTMLInputElement }) => {
    setSalary(e.target.value)
  }

  useEffect(() => {
    if (disabledInput) {
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [disabledInput])

  const handleClick = () => {
    if (!disabled) {
      setSalary('Não Divulgado')
      setDisabled(true)
    } else {
      setSalary('')
      setDisabled(false)
    }
  }

  return (
    <InputSalaryStyle isValidate={isValidate} widthDiv={widthDiv}>
      <div>
        <label>{label}</label>
        <button onClick={handleClick}>{!disabled ? 'Não Divulgar' : 'Divulgar'}</button>
      </div>
      <input type="text" onChange={handleChange} value={salary} disabled={disabled} placeholder={placeholder} />
    </InputSalaryStyle>
  )
}
